import { render, staticRenderFns } from "./ProtocolCreateView.vue?vue&type=template&id=58117402&scoped=true"
import script from "./ProtocolCreateView.vue?vue&type=script&lang=js"
export * from "./ProtocolCreateView.vue?vue&type=script&lang=js"
import style0 from "./ProtocolCreateView.vue?vue&type=style&index=0&id=58117402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58117402",
  null
  
)

export default component.exports